// extracted by mini-css-extract-plugin
export default {"box":"box__c3560","__dark-back":"__dark-back__c3560"};